import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = `${environment.apiUrl}/questions`;
  }

  public getQuestionByKey = (key: string): Observable<any> =>
    this.http.get<any>(`${this.baseUrl}/key/${encodeURIComponent(key)}`);

  public getQuestionsByAssessment = (assessmentId: string): Observable<any[]> =>
    this.http.get<any[]>(`${this.baseUrl}`, { params: { assessmentId } });

  public getQuestion = (id: string): Promise<any> =>
    this.http.get<any>(`${this.baseUrl}/${encodeURIComponent(id)}`).toPromise();

  public updateQuestion = (id: string, payload: any): Observable<void> =>
    this.http.put<void>(`${this.baseUrl}/${encodeURIComponent(id)}`, payload);

  public insertQuestion = (payload: any): Observable<string> =>
    this.http.post(`${this.baseUrl}`, payload, { responseType: 'text' });
}
